import {Div, HeaderBack} from 'components';
import {Ecolors, Icons} from 'constant';
import React from 'react';
import {navigate} from 'services';
import {useAppSelector} from 'store/hooks';
import {parseMultilanguage, removeUtf8} from 'utils';
import ButtonDownloadAgentcyFile from './ButtonDownloadAgentcyFile';
import ItemCard from './ItemCard';

function AgentcyInfoModal() {
  const currentUser = useAppSelector(state => state.authen.currentUser);

  const {agentcyInfo} = currentUser;

  return (
    <Div height={'100%'} backgroundColor={Ecolors.whiteColor}>
      <HeaderBack
        type={2}
        iconRight={!agentcyInfo?.isEsign ? Icons.edit : null}
        // iconRight={Icons.edit}
        title={`agentcy.thongtincongtacvien`}
        onRightPress={() => {
          navigate('EditAgentcyInfoModal');
        }}
      />
      <ItemCard
        title={`agentcy.loaidoitac`}
        content={parseMultilanguage(
          agentcyInfo?.agentTypeCode == 1
            ? `agentcy.dailybaohiem`
            : agentcyInfo?.agentTypeCode == 2
            ? `agentcy.canhan`
            : `agentcy.trong`,
        )}
        isLine={true}
      />
      <ItemCard
        title={`agentcy.masothuecanhan`}
        content={removeUtf8(agentcyInfo?.taxCode || ' ')}
        isLine={true}
      />
      <ItemCard
        title={`agentcy.matuvan`}
        content={removeUtf8(agentcyInfo?.agentCode || ' ')}
        isLine={true}
      />
      {agentcyInfo?.agentTypeCode != 2 && (
        <ItemCard
          title={`agentcy.thuoctongdaily`}
          content={removeUtf8(agentcyInfo?.gadName || ' ')}
          isLine={true}
        />
      )}
      <ButtonDownloadAgentcyFile />
    </Div>
  );
}

export default React.memo(AgentcyInfoModal);
